export default "__VITE_ASSET__Cb9$5zkX__"